import { createAsyncThunk } from '@reduxjs/toolkit';
import { AddOnCategory } from '../../../client/services';
import { toastHandler } from '../../../utils/toastHandler';
import { CreatePatchAddOnCategory, FindAddOnCategory, GetAddOnCategory } from './interface';

export const findAddOnCategory = createAsyncThunk(
  'addOnCategory/findAddOnCategory',
  async (values: FindAddOnCategory, { rejectWithValue }) => {
    try {
      const response = await AddOnCategory.find({
        query: values,
      });

      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const createAddOnCategory = createAsyncThunk(
  'addOnCategory/createAddOnCategory',
  async (values: CreatePatchAddOnCategory, { rejectWithValue }) => {
    try {
      const response = await AddOnCategory.create(values);
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const patchAddOnCategory = createAsyncThunk(
  'addOnCategory/patchAddOnCategory',
  async ({ id, ...values }: CreatePatchAddOnCategory, { rejectWithValue }) => {
    try {
      const response = await AddOnCategory.patch(id, values);
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const getAddOnCategory = createAsyncThunk(
  'addOnCategory/getAddOnCategory',
  async ({ id }: GetAddOnCategory, { rejectWithValue }) => {
    try {
      const response = await AddOnCategory.get(id);

      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);